// import React from 'react'
import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Menu } from "@mui/material";
// import './TemporaryDrawer.css'
// import Product from '../../product/Product.tsx'

import Product from "../../product/Product.tsx";
import dashboard from "./../../../assets/icons/menu.png";
import settings from "./../../../assets/icons/settings.png";
// import { Avatar, Button } from '@mui/material'
import Leo from "./../../../assets/images/Leo.png";
import product from "./../../../assets/icons/sections.png";
import subsection from "./../../../assets/icons/subsection.png";
import restaurantIcon from "./../../../assets/icons/Item.png";
import "./Topbar.css";
import AddMenu from "../../product/components/AddMenu/AddMenu.tsx";
import AddSection from "../../product/components/AddSection/AddSection.tsx";
import AddSubSection from "../../product/components/AddSubSection/AddSubSection.tsx";
import resBlack from "./../../../assets/icons/restaurantBlack.png";
import productBlack from "./../../../assets/icons/product (1).png";
import empBlack from "./../../../assets/icons/Emp.png";
import discount from "./../../../assets/icons/discount.png";
import addon from "./../../../assets/icons/setting.png";
import recomendedIMG from "./../../../assets/icons/recommend.png";
import subscriptionIMG from "./../../../assets/icons/subscription.png";
import wholeSaleIMG from "./../../../assets/icons/wholesaler.png";
import corporateIMG from "./../../../assets/icons/team.png";
import historyIMG from "./../../../assets/icons/history.png";
import scheduleImg from "./../../../assets/icons/schedule.png";
import inventoryImg from "./../../../assets/icons/inventory.png";
import keywordImg from "./../../../assets/icons/keyword.png";
import archiveImg from "./../../../assets/icons/archive.png";
import keywordTag from "./../../../assets/icons/hashtag.png";
import userImg from "./../../../assets/icons/user.png";
import jwt_decode from "jwt-decode";

import { useNavigate } from "react-router-dom";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import AddDiscountItems from "../../product/components/AddDiscountItems/AddDiscountItems.tsx";
import AddRecommendation from "../../product/components/AddRecommendation/AddRecommendation.tsx";
import AddSubscription from "../../product/components/AddSubscription/AddSubscription.tsx";
import AddCorporateMenu from "../../product/components/AddCorporateMenu/AddCorporateMenu.tsx";
import AddWholeSaleMenu from "../../product/components/AddWholeSaleMenu/AddWholeSaleMenu.tsx";
import SideBar from "../sidebar/SideBar.tsx";
import AddFoodHistory from "../../product/components/AddFoodHistory/AddFoodHistory.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import SchedulerView from "../../product/components/SchedulerView/SchedulerView.tsx";

import logo from "./../../../assets/images/LogoTransparent.png";
import AddOnSetup from "../../product/components/AddOnSetup/AddOnSetup.tsx";
import InventoryView from "../../product/components/InventoryView/InventoryView.tsx";
import axios from "axios";
import NotificationBell from "../../../components/NotificationBell.tsx";
import menu5 from "./../../../assets/icons/menu5.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import AddKeyword from "../../product/components/AddKeyword/AddKeyword.tsx";

import StorefrontIcon from "@mui/icons-material/Storefront";
import AddKeywordTag from "../../product/components/AddKeywordTag/AddKeywordTag.tsx";
import TopHeader from "../../../components/TopHeader.tsx";
import Archive from "../../product/components/Archive/Archive.tsx";
import RolesAndPermissions from "../../product/components/AddRolesAndPermissions/RolesAndPermissions.tsx";

type Anchor = "top" | "left" | "bottom" | "right";

function TemporaryDrawer() {
  const navigate = useNavigate();
  const apiAddress = process.env.REACT_APP_SECRET;

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [open, setOpen] = React.useState(false);

  const toggleDrawer =
    (anchor: Anchor) => (event: React.KeyboardEvent | React.MouseEvent) => {
      console.log(
        "(event as React.KeyboardEvent).key: " +
          (event as React.KeyboardEvent).key
      );
      console.log("event: " + event);
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };
  const clickMenuList = (props) => {
    console.log("props: " + props);
    if (props === "Manage restaurant") {
      navigate("/restaurant-setup");
    }
  };

  const [menuSelection, setMenuSelection] = React.useState(0);

  const changeMenu = (props) => {
    setMenuSelection(props);
  };
  const [age, setAge] = React.useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };

  const [tokenData, setTokenData] = React.useState({
    UserName: "",
  });
  React.useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    const parentrestaurant = JSON.parse(
      localStorage.getItem("parentrestaurant")
    );
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
    loadDataForRestaurant();
  }, []);

  const [restaurants, setRestaurant] = React.useState([]);
  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant"))
  );

  const loadDataForRestaurant = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          decodedData.UserId +
          "/" +
          restaurant.id
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        // list.push(response.data)
        // setRestaurantDatas(list);
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
          };
          list.push(obj);
        });

        setRestaurant(list);
      });
  };

  //restaurant selection start
  const [userid, setUserId] = React.useState("");
  const [restaurantList, setRestaurantList] = React.useState([]);
  const token = jwt_decode(localStorage.getItem("gotasteadmintoken"));
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));

  React.useEffect(() => {
    console.log(token);
    // var decodedData = {};
    if (token != null) {
      try {
        // decodedData = jwt_decode(token)

        setUserId(token.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + token.UserId)
      .then((response) => {
        console.log(response.data);

        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantList(list);
      });
  }, []);
  console.log(restaurantList);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const restaurantListopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  console.log(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuSelect = (props) => {
    console.log(props);
    localStorage.setItem("restaurant", JSON.stringify(props));

    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));

    handleClose();
  };
  //restaurant selection end

  //user logout dropdown start

  const [useranchorEl, setuseranchorEl] = React.useState(null);
  const userOpen = Boolean(useranchorEl);
  const handleUserClick = (event) => {
    setuseranchorEl(event.currentTarget);
  };
  const handleUserClose = () => {
    setuseranchorEl(null);
  };

  //user logout dropdown end
  const [totalNotification, setTotalNotification] = React.useState(null);
  const sendDataToParent = (number) => {
    // console.log('Total notification in top header', number);
    setTotalNotification(number);
  };
  const handleRestaurantSelect = (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    handleClose();
  };

  return (
    <>
      <TopHeader />
      <div className="d-flex">
        <div>
          <Box
            sx={{
              minWidth: 120,
              width: "13rem",
              marginTop: "1rem",
              marginBottom: "1rem",
              marginLeft: ".5rem",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                {selectedchildRestaurant.name}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age}
                label="Restaurant Name"
                onChange={handleChange}
              >
                {restaurants.map((dt, i) => {
                  return (
                    <MenuItem
                      onClick={() => {
                        handleRestaurantSelect(dt);
                      }}
                      selected={selectedchildRestaurant.name == dt.name}
                    >
                      {dt.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
      <div className="d-flex mt-2">
        <div className="">
          {/* <div className="searchBoxForProduct" style={{ padding: "10px" }}>
            <input
              type="text"
              placeholder="Search"
              className="form-control searchBar"
            />
          </div> */}
          <div
            className="scrollable-div"
            style={{ width: "13rem", height: "100vh" }}
          >
            {/* <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b>Setup</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} /> */}

            <div
              className={`menuItem ${menuSelection === 0 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => changeMenu(0)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={dashboard}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Menu{" "}
                </p>
              </div>
            </div>

            <div
              className={`menuItem ${menuSelection === 1 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(1)}
            >
              <div
                className="  d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={product}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Section
                </p>
              </div>
            </div>
            <div
              className={`menuItem ${menuSelection === 3 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(3)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={restaurantIcon}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Food Item
                </p>
              </div>
            </div>
            <div
              className={`menuItem ${menuSelection === 12 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(12)}
            >
              <div
                className="  d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={addon}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Add On
                </p>
              </div>
            </div>

            {/* removed Sub Sections */}
            {/* <div
              className={`menuItem ${menuSelection == 2 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(2)}
            >
              <div
                className="  d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={subsection}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Sub Section
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 14 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => changeMenu(14)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={keywordImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  KeyWord{" "}
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 15 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => changeMenu(15)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={archiveImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Archive{" "}
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 16 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => changeMenu(16)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={archiveImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Roles and permissions{" "}
                </p>
              </div>
            </div> */}

            {/* inventory section */}
            {/* <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b>Inventory</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} /> */}

            {/* <div
              className={`menuItem ${menuSelection == 13 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(13)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={inventoryImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Inventory
                </p>
              </div>
            </div> */}

            {/* <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b>Menu Setup with</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} /> */}

            {/* <div
              className={`menuItem ${menuSelection == 5 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(5)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={discount}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Discounted Item
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 6 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(6)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={recomendedIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Recommened Item
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 7 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(7)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={subscriptionIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Subscription{" "}
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 12 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(12)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={subscriptionIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Set Menu{" "}
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 8 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(8)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={corporateIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Coporate Menu
                </p>
              </div>
            </div> */}

            {/* <div
              className={`menuItem ${menuSelection == 9 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(9)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={wholeSaleIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  WholeSale Menu
                </p>
              </div>
            </div> */}

            {/* <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b>History Setup</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} /> */}

            {/* <div
              className={`menuItem ${menuSelection == 10 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(10)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={historyIMG}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Food History
                </p>
              </div>
            </div> */}

            {/* <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b>Settings</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} /> */}

            {/* <div
              className={`menuItem ${menuSelection == 11 ? "active" : ""}`}
              style={{ width: "100%", height: "3rem" }}
              onClick={() => changeMenu(11)}
            >
              <div
                className=" d-flex justify-content-start align-items-center  ms-4"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={scheduleImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  Scheduler
                </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* menu: 0, 1, 3, 12 */}
        {menuSelection === 0 ? (
          <div className="" style={{ marginLeft: "10px", width: "85vw" }}>
            <AddMenu />
          </div>
        ) : menuSelection === 1 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddSection />
          </div>
        ) : menuSelection === 2 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddSubSection />
          </div>
        ) : menuSelection === 3 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <Product></Product>
          </div>
        ) : menuSelection === 5 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddDiscountItems />
          </div>
        ) : menuSelection === 6 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddRecommendation />
          </div>
        ) : menuSelection === 7 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddSubscription />
          </div>
        ) : menuSelection === 8 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddCorporateMenu />
          </div>
        ) : menuSelection === 9 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddWholeSaleMenu />
          </div>
        ) : menuSelection === 10 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddFoodHistory />
          </div>
        ) : menuSelection === 11 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <SchedulerView />
          </div>
        ) : menuSelection === 12 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddOnSetup />
          </div>
        ) : menuSelection === 13 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <InventoryView />
          </div>
        ) : menuSelection === 14 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <AddKeyword />
          </div>
        ) : menuSelection === 15 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <Archive />
          </div>
        ) : menuSelection === 16 ? (
          <div className="" style={{ marginLeft: "10px", width: "100%" }}>
            <RolesAndPermissions></RolesAndPermissions>
          </div>
        ) : (
          <p>Coming soon</p>
        )}
      </div>
    </>
  );
}

export default TemporaryDrawer;
